import { Fragment } from 'react';

// "C9H8O4" with its counts as subscripts and a charge as a superscript ("CH6N+" -> CH₆N⁺, "Ca+2"
// -> Ca²⁺; the charge is written sign first, as PubChem does, so its digits can't be mistaken for a
// count). #1073: a paper of several pieces reads "C10H22 · 2 CH4": the count in front of a piece
// stays full size, and each piece keeps its own charge.
export function FormulaText({ formula }: { readonly formula: string }) {
  return (
    <>
      {formula.split(' · ').map((piece, index) => (
        <Fragment key={index}>
          {index > 0 ? ' · ' : null}
          <FormulaPiece piece={piece} />
        </Fragment>
      ))}
    </>
  );
}

function FormulaPiece({ piece }: { readonly piece: string }) {
  const [, count, body = piece, sign, magnitude] = /^(\d+ )?(.*?)(?:([+-])(\d*))?$/.exec(piece) ?? [];
  return (
    <>
      {count}
      {body
        .split(/(\d+)/)
        .map((part, index) =>
          /^\d+$/.test(part) ? <sub key={index}>{part}</sub> : <Fragment key={index}>{part}</Fragment>
        )}
      {sign ? (
        <sup>
          {magnitude}
          {sign === '-' ? '−' : '+'}
        </sup>
      ) : null}
    </>
  );
}

/** #1115: a Hill formula with its net charge, as FormulaText reads it ("C2H5O" and -1 -> "C2H5O-"). */
export function withCharge(formula: string, charge: number | null): string {
  if (!charge) return formula;
  const magnitude = Math.abs(charge);
  return formula + (charge > 0 ? '+' : '-') + (magnitude === 1 ? '' : magnitude);
}
